var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiwi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29384F;}\n\t.st1{fill:#9DC53D;}\n\t.st2{fill:#70B643;}\n\t.st3{fill:#B2D067;}\n\t.st4{fill:#FFFFFE;}\n\t.st5{fill:#856D4D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 106.88,
    cy: 105.25,
    rx: 42.07,
    ry: 41.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.88,59.36c-25.24,0-45.77,20.58-45.77,45.89c0,25.3,20.53,45.89,45.77,45.89 c25.24,0,45.77-20.58,45.77-45.89C152.65,79.94,132.12,59.36,106.88,59.36z M106.88,143c-21.16,0-38.37-16.94-38.37-37.76 s17.21-37.76,38.37-37.76c21.15,0,38.37,16.94,38.37,37.76S128.03,143,106.88,143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 106.44,
    cy: 105.25,
    rx: 23.99,
    ry: 26.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.44,74.85c-15.27,0-27.69,13.64-27.69,30.4c0,16.76,12.42,30.4,27.69,30.4c15.27,0,27.7-13.64,27.7-30.4 C134.13,88.48,121.71,74.85,106.44,74.85z M106.44,127.51c-11.18,0-20.28-9.99-20.28-22.27s9.1-22.27,20.28-22.27 c11.19,0,20.29,9.99,20.29,22.27S117.62,127.51,106.44,127.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.74,111.1l-67.6-15.25c-0.56-0.12-1.13,0.27-1.25,0.91c-0.12,0.63,0.25,1.24,0.82,1.37l67.6,15.25 c0.07,0.02,0.14,0.02,0.21,0.02c0.49,0,0.93-0.38,1.04-0.93C141.68,111.84,141.31,111.23,140.74,111.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.99,84.69l-55.3,40.37c-0.49,0.35-0.62,1.08-0.29,1.61c0.2,0.34,0.54,0.52,0.88,0.52 c0.2,0,0.41-0.06,0.59-0.2l55.3-40.37c0.49-0.35,0.62-1.08,0.29-1.61C135.13,84.48,134.47,84.34,133.99,84.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.41,69.71c-0.55-0.13-1.13,0.28-1.24,0.91l-12.44,68.25c-0.12,0.63,0.26,1.24,0.83,1.37 c0.07,0.02,0.14,0.02,0.21,0.02c0.49,0,0.93-0.38,1.04-0.93l12.44-68.25C115.35,70.45,114.98,69.83,114.41,69.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.4,75.59c-0.32-0.54-0.98-0.69-1.46-0.34c-0.49,0.35-0.63,1.07-0.31,1.61l33.87,56.78 c0.2,0.34,0.54,0.53,0.88,0.53c0.2,0,0.4-0.06,0.58-0.19c0.49-0.35,0.63-1.07,0.31-1.61L91.4,75.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.89,87.45c-0.48-0.35-1.14-0.22-1.47,0.32c-0.33,0.53-0.2,1.25,0.29,1.61l43.66,32.24 c0.18,0.13,0.39,0.2,0.59,0.2c0.34,0,0.67-0.18,0.88-0.51c0.33-0.53,0.2-1.25-0.29-1.61L84.89,87.45z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.87,97.01l-61.65,12.78c-0.57,0.12-0.95,0.73-0.84,1.36c0.09,0.56,0.54,0.95,1.04,0.95 c0.07,0,0.13-0.01,0.2-0.02l61.65-12.78c0.57-0.12,0.95-0.73,0.84-1.36C140,97.3,139.44,96.89,138.87,97.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.23,75.83c-0.49-0.36-1.15-0.21-1.47,0.33l-30.96,51.41c-0.32,0.54-0.19,1.25,0.3,1.61 c0.18,0.13,0.38,0.19,0.58,0.19c0.34,0,0.68-0.18,0.88-0.52l30.96-51.41C125.86,76.91,125.72,76.19,125.23,75.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.56,78.56c-0.57,0.11-0.96,0.72-0.85,1.35l8.2,49.81c0.09,0.56,0.54,0.95,1.04,0.95 c0.06,0,0.13-0.01,0.19-0.02c0.57-0.11,0.96-0.72,0.85-1.35l-8.2-49.81C104.68,78.86,104.12,78.46,103.56,78.56z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.77,100.38c-4.8,2.72-7.77,6.92-6.61,9.37c1.15,2.45,5.28,6.16,10.79-0.48c3.64-4.39,7.77-6.92,6.61-9.37 C114.4,97.44,109.57,97.66,104.77,100.38z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.05,95.63c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C97.7,94.87,96.66,94.9,96.05,95.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.35,90.25c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C99,89.48,97.96,89.52,97.35,90.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.25,91.67c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C103.9,90.91,102.87,90.95,102.25,91.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.25,87.94c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C106.9,87.17,105.87,87.21,105.25,87.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M108.65,91.23c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C110.3,90.46,109.27,90.5,108.65,91.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M113.36,89.14c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C115.01,88.37,113.97,88.41,113.36,89.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.76,92.43c-0.62,0.72-0.58,1.86,0.08,2.53c0.66,0.68,1.69,0.64,2.31-0.09c0.62-0.72,0.58-1.86-0.08-2.53 C118.41,91.67,117.38,91.71,116.76,92.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120.08,97.3c-0.9,0.05-1.59,0.89-1.55,1.88s0.81,1.75,1.71,1.7c0.9-0.05,1.6-0.89,1.55-1.88 C121.74,98.01,120.98,97.25,120.08,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M122.69,102.07c-0.9,0.05-1.59,0.89-1.55,1.88c0.05,0.99,0.81,1.75,1.71,1.7c0.9-0.05,1.59-0.89,1.55-1.88 C124.36,102.78,123.59,102.02,122.69,102.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.35,104.94c-0.9,0.05-1.59,0.89-1.55,1.88c0.05,0.99,0.81,1.75,1.71,1.7c0.9-0.05,1.59-0.89,1.55-1.88 C120.02,105.65,119.25,104.89,118.35,104.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.7,109.91c-0.9,0.05-1.6,0.89-1.55,1.88c0.05,0.99,0.81,1.75,1.71,1.7c0.9-0.05,1.59-0.89,1.55-1.88 C120.37,110.62,119.6,109.86,118.7,109.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.18,110.3c-0.9,0.05-1.6,0.89-1.55,1.88c0.05,0.99,0.81,1.75,1.71,1.7c0.9-0.05,1.59-0.89,1.55-1.88 C115.85,111.01,115.08,110.25,114.18,110.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.27,115.46c-0.9,0.05-1.59,0.89-1.55,1.88c0.05,0.99,0.81,1.75,1.71,1.7c0.9-0.05,1.59-0.89,1.55-1.88 S113.17,115.41,112.27,115.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.75,115.85c-0.9,0.05-1.59,0.89-1.55,1.88c0.05,0.99,0.81,1.75,1.71,1.7c0.9-0.05,1.59-0.89,1.55-1.88 C109.42,116.56,108.65,115.8,107.75,115.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M101.95,118.09c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C103.13,119.57,102.77,118.51,101.95,118.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.89,118.43c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C98.07,119.91,97.71,118.84,96.89,118.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.59,112.87c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C97.76,114.35,97.41,113.28,96.59,112.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.41,110.91c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C93.59,112.39,93.23,111.33,92.41,110.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.19,106.33c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C95.37,107.81,95.01,106.75,94.19,106.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M90.91,102.09c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C92.09,103.57,91.73,102.5,90.91,102.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M92.69,97.51c-0.82-0.41-1.79-0.02-2.17,0.88c-0.38,0.9-0.02,1.96,0.8,2.38c0.82,0.41,1.79,0.02,2.17-0.88 C93.87,98.98,93.51,97.92,92.69,97.51z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwi);
export default __webpack_public_path__ + "static/media/Kiwi.cd7416a987ebf5944b8122a54020e9d7.svg";
export { ForwardRef as ReactComponent };